import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { StatementItemReference } from "@/payroll/ai-script/statement/statement-renderer";
import { isFigureValue } from "@/payroll/pack-chat/reference-label";

/** A compact summary of the figure selected for the new thread. */
export const SelectedStatementItemPreview = ({
  item,
}: {
  item: StatementItemReference;
}) => {
  const value = item.amount;
  const figure = isFigureValue(value);
  const details = [
    item.line ? item.heading : undefined,
    figure ? undefined : value,
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Stack
      direction="row"
      align="start"
      justify="between"
      gap={4}
      className="w-full border-y border-line py-3"
    >
      <Stack gap={0} align="stretch" className="min-w-0">
        <Text
          variant="label"
          className="truncate"
          title={item.line ?? item.heading}
        >
          {item.line ?? item.heading}
        </Text>
        {details && (
          <Text
            variant="caption"
            tone="muted"
            className="truncate"
            title={details}
          >
            {details}
          </Text>
        )}
      </Stack>
      {figure && value && (
        <Text variant="title" className="shrink-0">
          {value}
        </Text>
      )}
    </Stack>
  );
};
